import { render, staticRenderFns } from "./RoomPage.vue?vue&type=template&id=79628704&scoped=true"
import script from "./RoomPage.vue?vue&type=script&lang=js"
export * from "./RoomPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/room.css?vue&type=style&index=0&id=79628704&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79628704",
  null
  
)

export default component.exports